var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import classNames from 'classnames';
import { get } from 'lodash';
import { LinkLineVariant } from '../types';
import { LINK_SHADOW_FILTER_KEY } from './ShadowFilters';
import { useLinkState } from '../context/linkState';
import { NODE_DIAMOND_HEIGHT } from '../node/NodeShapeFactory';
var InteractiveLink = function (_a) {
    var id = _a.id, source = _a.source, target = _a.target, lineVariant = _a.lineVariant, arrowVariant = _a.arrowVariant, withShadow = _a.withShadow, onClick = _a.onClick;
    var _b = useLinkState(id), sourcePosition = _b[0], targetPosition = _b[1], sourceNodePosition = _b[2], sourceNodeShape = _b[3];
    if (!sourcePosition || !targetPosition || !sourceNodePosition || !sourceNodeShape) {
        return null;
    }
    var commonLinkAttrs = {
        filter: withShadow ? "url(#" + LINK_SHADOW_FILTER_KEY + ")" : undefined,
        markerEnd: "url(#" + arrowVariant + ")",
    };
    var getLinkShape = function () {
        if (source !== target) {
            return (React.createElement("line", __assign({ x1: sourcePosition.x, y1: sourcePosition.y, x2: targetPosition.x, y2: targetPosition.y }, commonLinkAttrs)));
        }
        else {
            var radius = get(sourceNodeShape.attrs, 'height', NODE_DIAMOND_HEIGHT);
            var startY = sourceNodePosition.y + (radius * 0.5);
            var endY = sourceNodePosition.y - (radius * 0.5);
            return (React.createElement("path", __assign({ d: "M " + sourceNodePosition.x + " " + startY + " A " + radius + " " + radius + " 0 1 1 " + sourceNodePosition.x + " " + endY, fill: 'none' }, commonLinkAttrs)));
        }
    };
    return (React.createElement("g", { className: classNames('interactiveLink', "link-" + source + "-" + target, { 'interactiveLink--clickable': !!onClick }, { 'interactiveLink--dashed': LinkLineVariant.DASHED_LINE === lineVariant }), onClick: onClick }, getLinkShape()));
};
export default InteractiveLink;
//# sourceMappingURL=InteractiveLink.js.map